var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-loading"},[(!_vm.organizationName)?_c('div',{staticClass:"loading"}):_c('div',{staticClass:"loading-text"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('h2',[_vm._v(_vm._s(_vm.subTitle === '' ? _vm.$locale.baseText('loading.organization') : _vm.subTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }